var exports = {
  "zr": "GuildBoostConfirmModal.module__root___d2VnRn",
  "ZK": "GuildBoostConfirmModal.module__hero___d2VnRn",
  "wh": "GuildBoostConfirmModal.module__heroGlow___d2VnRn",
  "CC": "GuildBoostConfirmModal.module__gem___d2VnRn",
  "Fx": "GuildBoostConfirmModal.module__gemPop___d2VnRn",
  "DD": "GuildBoostConfirmModal.module__title___d2VnRn",
  "VA": "GuildBoostConfirmModal.module__subtitle___d2VnRn",
  "rf": "GuildBoostConfirmModal.module__body___d2VnRn",
  "nd": "GuildBoostConfirmModal.module__panel___d2VnRn",
  "QU": "GuildBoostConfirmModal.module__slotsRow___d2VnRn",
  "eO": "GuildBoostConfirmModal.module__slotsLabel___d2VnRn",
  "L3": "GuildBoostConfirmModal.module__slotsText___d2VnRn",
  "FL": "GuildBoostConfirmModal.module__pips___d2VnRn",
  "yF": "GuildBoostConfirmModal.module__pip___d2VnRn",
  "vK": "GuildBoostConfirmModal.module__pipUsed___d2VnRn",
  "lm": "GuildBoostConfirmModal.module__notice___d2VnRn",
  "o1": "GuildBoostConfirmModal.module__actions___d2VnRn",
  "Ng": "GuildBoostConfirmModal.module__boostButtonIcon___d2VnRn",
  "Lq": "GuildBoostConfirmModal.module__loading___d2VnRn",
  "mO": "GuildBoostConfirmModal.module__particles___d2VnRn",
  "R7": "GuildBoostConfirmModal.module__particle___d2VnRn",
  "Nk": "GuildBoostConfirmModal.module__burst___d2VnRn",
};

module.exports = exports;
